import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages as m } from '../../../../constants';
import * as D from '../../../../deps';

import './BackstagePodcastProgramNoEpisodes.scss';

const BackstagePodcastProgramNoEpisodes = props => {
  return (
    <div className='BackstagePodcastProgramNoEpisodes'>
      <div className='BackstagePodcastProgramNoEpisodes__text'>
        <FormattedMessage {...m.noEpisodes} />
      </div>
      <D.ButtonT3 theme={D.ButtonT3Theme.BLUE} href={D.getBrowsePodcastsPath()}>
        <FormattedMessage {...m.browseMorePodcasts} />
      </D.ButtonT3>
    </div>
  );
};

export default BackstagePodcastProgramNoEpisodes;
